/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIWaste
 */
export interface APIWaste {
    /**
     * 
     * @type {string}
     * @memberof APIWaste
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIWaste
     */
    readonly article: string;
    /**
     * 
     * @type {Date}
     * @memberof APIWaste
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIWaste
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof APIWaste
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof APIWaste
     */
    comment: string;
}

/**
 * Check if a given object implements the APIWaste interface.
 */
export function instanceOfAPIWaste(value: object): value is APIWaste {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    return true;
}

export function APIWasteFromJSON(json: any): APIWaste {
    return APIWasteFromJSONTyped(json, false);
}

export function APIWasteFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIWaste {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'article': json['article'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'amount': json['amount'],
        'comment': json['comment'],
    };
}

export function APIWasteToJSON(value?: Omit<APIWaste, 'self'|'article'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'comment': value['comment'],
    };
}

